'use strict';

frontendApp.directive('iioTheme', ['$rootScope', 'ThemeService', function ($rootScope, ThemeService) {

  // Map a tenant theme onto the --brand-* custom properties consumed by
  // app/styles/_theme-bootstrap.scss.
  //
  // This used to string-build a stylesheet and append it to <head>. The
  // selectors now live in SCSS; only the values are computed here. The pusher
  // derivations below are unchanged, so tenant rendering is identical.
  //
  // Note pusher's hex6() already includes the leading '#'.
  var getThemeVars = function (theme) {
    var linkColor = pusher.color(theme.linkColor);
    var navColor = pusher.color(theme.navBackgroundColor);
    var backgroundColor = pusher.color(theme.backgroundColor);
    var textColor = pusher.color(theme.textColor);
    var navTextColor = pusher.color(theme.navTextColor);

    return {
      '--brand-page-bg': theme.backgroundColor,
      '--brand-row-hover': backgroundColor.shade(.025).hex6(),
      '--brand-surface-alt': backgroundColor.shade(.05).hex6(),
      '--brand-border': backgroundColor.shade(.1).hex6(),
      '--brand-icon-muted': backgroundColor.shade(.15).hex6(),
      '--brand-border-strong': backgroundColor.shade(.2).hex6(),
      '--brand-muted': backgroundColor.shade(.3).hex6(),
      '--brand-muted-strong': backgroundColor.shade(.5).hex6(),

      '--brand-text': theme.textColor,
      '--brand-text-soft': textColor.tint(.4).hex6(),

      '--brand-link': theme.linkColor,
      '--brand-link-hover': linkColor.shade(.15).hex6(),
      '--brand-primary': theme.linkColor,
      '--brand-primary-active': linkColor.shade(.10).hex6(),
      '--brand-subnav': linkColor.tone(.7).hex6(),

      '--brand-nav-bg': theme.navBackgroundColor,
      '--brand-nav-fg': theme.navTextColor,
      '--brand-nav-fg-muted': navTextColor.blend(navColor, .35).hex6(),
      '--brand-nav-btn': navColor.tint(.2).hex6(),
      '--brand-nav-btn-open': navColor.shade(.1).hex6()
    };
  };

  return {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {

      scope.theme = ThemeService.getCurrentTheme();
      scope.$on(ThemeService.EVENTS.THEME_CHANGED, function (evt, theme) {
        scope.theme = theme;
      });

      scope.$watch('theme', function (val) {
        if (_.isEmpty(val)) return;

        var root = document.documentElement;
        var vars = getThemeVars(val);
        angular.forEach(_.pairs(vars), function (pair) {
          root.style.setProperty(pair[0], pair[1]);
        });

        $('head title').text(val.name);

        if (val['messageType'] && val['message']) {
          $('#themeMessage')
            .addClass('alert-' + val['messageType'])
            .text(val['message'])
            .show();
        }
      });

    }
  }
}]);
